import $ from "jquery";

const popupMenu = () => {
  if (typeof window.elementorProFrontend === "undefined") return;

  // Close popup when clicking overlay
  $(document).on("click", ".dialog-lightbox-message", function () {
    $(document).trigger("elementor/popup/hide");
  });

  // Prevent close when clicking actual popup content
  $(document).on(
    "click",
    ".dialog-lightbox-message [data-elementor-id]",
    function (e) {
      e.stopPropagation();
    },
  );
};

try {
  popupMenu();
} catch (error) {
  throw Error(error);
}
